import { FloatingNode } from '@floating-ui/react';
import React from 'react';

import { useContextMenu } from '../hooks/use-context-menu';
import { ExpandableMenuItem } from './expandable-menu-item';

type Props = {
  label: string;
  children: React.ReactNode;
};

const SubMenu = (props: Props) => {
  const {
    hasFocusInside,
    isOpen,
    renderList,
    mergedRefs,
    getReferenceProps,
    parent,
    isNested,
    nodeId,
    setHasFocusInside,
  } = useContextMenu({
    children: props.children,
  });

  return (
    <FloatingNode id={nodeId}>
      <ExpandableMenuItem
        data-focus-inside={hasFocusInside ? '' : undefined}
        data-nested={isNested ? '' : undefined}
        data-open={isOpen ? '' : undefined}
        label={props.label}
        ref={mergedRefs}
        {...getReferenceProps(
          parent.getItemProps({
            ...props,
            onFocus(event: React.FocusEvent<HTMLButtonElement>) {
              setHasFocusInside(false);
              parent.setHasFocusInside(true);
            },
            onContextMenu(event) {
              event.preventDefault();
              event.stopPropagation();
            },
          }),
        )}
      />
      {renderList()}
    </FloatingNode>
  );
};

export { SubMenu };
